import React from "react";
import { CgSpinner } from "react-icons/cg";

function UpgradeConfirmModal({ onClose, onConfirm, isLoading }) {
  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={() => !isLoading && onClose()}
    >
      <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)" }} />

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          backgroundColor: "#0f0d1a",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "1.25rem",
          padding: "1.75rem",
          width: "min(90vw, 430px)",
          boxShadow: "0 32px 64px rgba(0,0,0,0.6)",
        }}
      >
        <h3 style={{ color: "#fff", fontSize: "1.05rem", fontWeight: 700, marginBottom: "0.4rem", fontFamily: "Manrope,sans-serif" }}>
          Upgrade your plan?
        </h3>
        <p style={{ color: "#9c98bf", fontSize: "0.83rem", marginBottom: "1.25rem", lineHeight: 1.6, fontFamily: "Manrope,sans-serif" }}>
          By upgrading, your current plan will be cancelled. You can then choose a new plan.
        </p>
        <div style={{ padding: "1.1rem", borderRadius: "1rem", backgroundColor: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", marginBottom: "1.5rem" }}>
          <h4 style={{ color: "#fff", fontSize: "0.9rem", fontWeight: 600, marginBottom: "0.35rem", fontFamily: "Manrope,sans-serif" }}>Your projects are safe</h4>
          <p style={{ color: "#9c98bf", fontSize: "0.8rem", lineHeight: 1.6, fontFamily: "Manrope,sans-serif" }}>
            Your projects, templates, and settings will remain securely saved.
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
          <button
            onClick={onClose}
            disabled={isLoading}
            style={{ padding: "0.55rem 1.1rem", fontSize: "0.83rem", backgroundColor: "rgba(255,255,255,0.05)", color: "#eee9ff", border: "1px solid rgba(255,255,255,0.05)", borderRadius: "0.65rem", cursor: isLoading ? "not-allowed" : "pointer", fontFamily: "Manrope,sans-serif" }}
          >
            Keep Current Plan
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              display: "flex", alignItems: "center", gap: "0.4rem",
              padding: "0.55rem 1.25rem", fontSize: "0.83rem", fontWeight: 600,
              backgroundColor: "#7c5cff", color: "#fff", border: "none", borderRadius: "0.65rem",
              cursor: isLoading ? "not-allowed" : "pointer", opacity: isLoading ? 0.7 : 1,
              fontFamily: "Manrope,sans-serif",
            }}
          >
            {isLoading && <CgSpinner className="animate-spin" />}
            Cancel & Upgrade
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradeConfirmModal;
